module.exports = __webpack_public_path__ + "img/img-introduce-004.a49445dc.png";